import Vue from 'vue';
export const EventBus = new Vue();
export const ORCAMENTO_EDIT_FORBIDDEN_EVENT = 'orcamento-edit-forbidden';
